import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IZendeskJWTTokenPayload, IZendeskJWTTokenResponse } from '../../../entity/interface/iAuthApis';
import { IAuthRepository } from '../../repositories/interfaces/iAuthRepository';
import { JsonType } from '@intigral/types';

export interface IZendeskJWTTokenUseCase {
    execute(
        payload: IZendeskJWTTokenPayload,
        authToken: string,
        authSign: string,
        identityToken: string,
        apiToken: { [key: string]: string }
    ): Promise<IZendeskJWTTokenResponse['data']>;
}

export class ZendeskJWTTokenUseCase implements IZendeskJWTTokenUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get authRepo(): IAuthRepository {
        return container.resolve<IAuthRepository>(DI.REPOSITORIES.IAuthRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }
    async execute(
        payload: IZendeskJWTTokenPayload,
        authToken: string,
        authSign: string,
        identityToken: string,
        apiToken: { [key: string]: string }
    ): Promise<IZendeskJWTTokenResponse['data']> {
        const response = await this.authRepo.zendeskJWTToken(payload, authToken, authSign, identityToken, apiToken);
        return response.data;
    }
}
